export enum FieldKey {
  ItemEmployeeRelationType = 'SchemalessFilter.ItemEmployeeRelationType',
  ExcludeSecondary = 'SchemalessFilter.ExcludeSecondary'
}
